import { render, staticRenderFns } from "./WissenIcon.vue?vue&type=template&id=26dc0f1c&scoped=true&"
var script = {}
import style0 from "./WissenIcon.vue?vue&type=style&index=0&id=26dc0f1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dc0f1c",
  null
  
)

export default component.exports